import swal from 'sweetalert2'

export default function accountSelector (accounts, formData) {
  const accountSelections = {}
  accounts.forEach(account => {
    const accountTotal = account.transactions
      .reduce((sum, transaction) => {
        return Math.round(sum + parseFloat(transaction.TransAmount))
      }, 0)
    const formattedTotal = (Math.round(accountTotal * 100) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    accountSelections[account.clientData.ClientId] = `${account.clientData.TrustName} - Balance: ${formattedTotal}`
  })

  swal({
    title: `Select An Account to View`,
    input: 'select',
    buttonsStyling: false,
    inputOptions: accountSelections,
    confirmButtonClass: 'btn btn-success btn-fill',
    preConfirm: (accountSelected) => {
      return selectAccount.call(this, accountSelected)
    }
  })
}

function selectAccount (clientId) {
  const loginData = { ...this.model, clientId }
  return this.$http.post('/client/login', loginData)
    .then(response => {
      if (response.data.authenticated) {
        if (response.data.accounts) {
          this.accountSelector(response.data.accounts, this.model)
        } else {
          this.viewClient(response.data)
        }
      } else {
        this.serverError = response.data.error
      }
    })
    .catch(error => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Home/Forms/AccountSelector.js